/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuthLoginRequest,
  AuthLogoutRequest,
  AuthMeResponse,
  AuthOtpRequestRequest,
  AuthOtpRequestResponse,
  AuthOtpVerifyRequest,
  AuthOtpVerifyResponse,
  AuthRefreshRequest,
  AuthRefreshResponse,
  AuthUpdatePhone200,
  AuthUpdatePhoneBody,
  ErrorResponse
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Вход по email и паролю
 */
export const authLogin = (
    authLoginRequest: AuthLoginRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AuthOtpVerifyResponse>(
      {url: `/api/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authLoginRequest, signal
    },
      options);
    }
  


export const getAuthLoginMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,{data: AuthLoginRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,{data: AuthLoginRequest}, TContext> => {

const mutationKey = ['authLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogin>>, {data: AuthLoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  authLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authLogin>>>
    export type AuthLoginMutationBody = AuthLoginRequest
    export type AuthLoginMutationError = ErrorResponse

    /**
 * @summary Вход по email и паролю
 */
export const useAuthLogin = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,{data: AuthLoginRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogin>>,
        TError,
        {data: AuthLoginRequest},
        TContext
      > => {

      const mutationOptions = getAuthLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Refresh tokens
 */
export const authRefresh = (
    authRefreshRequest: AuthRefreshRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AuthRefreshResponse>(
      {url: `/api/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authRefreshRequest, signal
    },
      options);
    }
  


export const getAuthRefreshMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRefresh>>, TError,{data: AuthRefreshRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authRefresh>>, TError,{data: AuthRefreshRequest}, TContext> => {

const mutationKey = ['authRefresh'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRefresh>>, {data: AuthRefreshRequest}> = (props) => {
          const {data} = props ?? {};

          return  authRefresh(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof authRefresh>>>
    export type AuthRefreshMutationBody = AuthRefreshRequest
    export type AuthRefreshMutationError = ErrorResponse

    /**
 * @summary Refresh tokens
 */
export const useAuthRefresh = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRefresh>>, TError,{data: AuthRefreshRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authRefresh>>,
        TError,
        {data: AuthRefreshRequest},
        TContext
      > => {

      const mutationOptions = getAuthRefreshMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Logout (revoke refresh token)
 */
export const authLogout = (
    authLogoutRequest: AuthLogoutRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/auth/logout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authLogoutRequest, signal
    },
      options);
    }
  


export const getAuthLogoutMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,{data: AuthLogoutRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,{data: AuthLogoutRequest}, TContext> => {

const mutationKey = ['authLogout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogout>>, {data: AuthLogoutRequest}> = (props) => {
          const {data} = props ?? {};

          return  authLogout(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof authLogout>>>
    export type AuthLogoutMutationBody = AuthLogoutRequest
    export type AuthLogoutMutationError = ErrorResponse

    /**
 * @summary Logout (revoke refresh token)
 */
export const useAuthLogout = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,{data: AuthLogoutRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogout>>,
        TError,
        {data: AuthLogoutRequest},
        TContext
      > => {

      const mutationOptions = getAuthLogoutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Request OTP
 */
export const authOtpRequest = (
    authOtpRequestRequest: AuthOtpRequestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AuthOtpRequestResponse>(
      {url: `/api/auth/otp/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authOtpRequestRequest, signal
    },
      options);
    }
  


export const getAuthOtpRequestMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authOtpRequest>>, TError,{data: AuthOtpRequestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authOtpRequest>>, TError,{data: AuthOtpRequestRequest}, TContext> => {

const mutationKey = ['authOtpRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authOtpRequest>>, {data: AuthOtpRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  authOtpRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthOtpRequestMutationResult = NonNullable<Awaited<ReturnType<typeof authOtpRequest>>>
    export type AuthOtpRequestMutationBody = AuthOtpRequestRequest
    export type AuthOtpRequestMutationError = ErrorResponse

    /**
 * @summary Request OTP
 */
export const useAuthOtpRequest = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authOtpRequest>>, TError,{data: AuthOtpRequestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authOtpRequest>>,
        TError,
        {data: AuthOtpRequestRequest},
        TContext
      > => {

      const mutationOptions = getAuthOtpRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Verify OTP
 */
export const authOtpVerify = (
    authOtpVerifyRequest: AuthOtpVerifyRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AuthOtpVerifyResponse>(
      {url: `/api/auth/otp/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authOtpVerifyRequest, signal
    },
      options);
    }
  


export const getAuthOtpVerifyMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authOtpVerify>>, TError,{data: AuthOtpVerifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authOtpVerify>>, TError,{data: AuthOtpVerifyRequest}, TContext> => {

const mutationKey = ['authOtpVerify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authOtpVerify>>, {data: AuthOtpVerifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  authOtpVerify(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthOtpVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof authOtpVerify>>>
    export type AuthOtpVerifyMutationBody = AuthOtpVerifyRequest
    export type AuthOtpVerifyMutationError = ErrorResponse

    /**
 * @summary Verify OTP
 */
export const useAuthOtpVerify = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authOtpVerify>>, TError,{data: AuthOtpVerifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authOtpVerify>>,
        TError,
        {data: AuthOtpVerifyRequest},
        TContext
      > => {

      const mutationOptions = getAuthOtpVerifyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get current user info
 */
export const authMe = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AuthMeResponse>(
      {url: `/api/auth/me`, method: 'GET', signal
    },
      options);
    }
  



export const getAuthMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }

    
export const getAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authMe>>> = ({ signal }) => authMe(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof authMe>>>
export type AuthMeQueryError = ErrorResponse


export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMe>>,
          TError,
          Awaited<ReturnType<typeof authMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMe>>,
          TError,
          Awaited<ReturnType<typeof authMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user info
 */

export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update current user phone number
 */
export const authUpdatePhone = (
    authUpdatePhoneBody: AuthUpdatePhoneBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<AuthUpdatePhone200>(
      {url: `/api/auth/me/phone`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: authUpdatePhoneBody
    },
      options);
    }
  


export const getAuthUpdatePhoneMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdatePhone>>, TError,{data: AuthUpdatePhoneBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authUpdatePhone>>, TError,{data: AuthUpdatePhoneBody}, TContext> => {

const mutationKey = ['authUpdatePhone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authUpdatePhone>>, {data: AuthUpdatePhoneBody}> = (props) => {
          const {data} = props ?? {};

          return  authUpdatePhone(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthUpdatePhoneMutationResult = NonNullable<Awaited<ReturnType<typeof authUpdatePhone>>>
    export type AuthUpdatePhoneMutationBody = AuthUpdatePhoneBody
    export type AuthUpdatePhoneMutationError = unknown

    /**
 * @summary Update current user phone number
 */
export const useAuthUpdatePhone = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdatePhone>>, TError,{data: AuthUpdatePhoneBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authUpdatePhone>>,
        TError,
        {data: AuthUpdatePhoneBody},
        TContext
      > => {

      const mutationOptions = getAuthUpdatePhoneMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    